import {ManagedMethodKind} from '@entities/paymentMethod';
import {ManagedMethodsTable} from './ManagedMethodsTable';

export const DepositMethodsTab = () => (
  <ManagedMethodsTable kind={ManagedMethodKind.deposit} />
);
